import api, { type Article, type PaginatedResponse } from './api';

/**
 * Fetch paginated bookmarked articles.
 */
export async function getBookmarks(
  page = 1,
  limit = 20
): Promise<PaginatedResponse<Article>> {
  const response = await api.get<PaginatedResponse<Article>>('/bookmarks', {
    params: { page, limit },
  });
  return response.data;
}

/**
 * Fetch all bookmarked article IDs for the current user.
 */
export async function getBookmarkIds(): Promise<number[]> {
  const response = await api.get<{ ids: number[] }>('/bookmarks/ids');
  return response.data.ids;
}

/**
 * Add a bookmark for an article.
 */
export async function addBookmark(articleId: number): Promise<void> {
  await api.post('/bookmarks', { articleId });
}

/**
 * Remove a bookmark for an article.
 */
export async function removeBookmark(articleId: number): Promise<void> {
  await api.delete(`/bookmarks/${articleId}`);
}
